import { AsyncPipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { LetDirective } from '@ngrx/component';

import { PrivaFormGroupComponent } from '@priva/components/form-group';
import { PrivaSelectComponent } from '@priva/components/select';
import { PrivaLocalizationModule } from '@priva/localization';

import { Activity } from '../../features/activity-selector/models';
import { ProductBoxRegistration } from './models';
import { ProductBoxStore } from './product-box.store';

@Component({
    selector: 'app-product-box',
    imports: [
        PrivaLocalizationModule,
        AsyncPipe,
        LetDirective,
        PrivaSelectComponent,
        ReactiveFormsModule,
        PrivaFormGroupComponent,
    ],
    providers: [ProductBoxStore],
    templateUrl: './product-box.component.html',
    styleUrl: './product-box.component.scss',
})
export class ProductBoxComponent {
    private productBoxStore = inject(ProductBoxStore);

    activity = input(undefined, {
        transform: (value: Activity | undefined) => {
            this._activity = value;
            this.productBoxStore.updateActivity(value);
            return this._activity;
        },
    });

    productBoxUpdated = output<ProductBoxRegistration[]>();

    private _activity: Activity | undefined;
    productBoxes$ = this.productBoxStore.productBoxes$;
    productBoxControl = new FormControl<number | undefined>(undefined);
    readonly productBoxRegistrations = this.productBoxStore.productBoxRegistrations;

    constructor() {
        this.productBoxes$.pipe(takeUntilDestroyed()).subscribe((productBoxes) => {
            const defaultProductBox = productBoxes.privaSelectOption.find(({ selected }) => selected);
            if (defaultProductBox) {
                this.productBoxControl.setValue(Number(defaultProductBox.value));
            }
        });

        this.productBoxControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((formValue) => {
            if (formValue) {
                this.productBoxStore.updateProductBoxRegistrations({
                    productBoxNumber: Number(formValue),
                    amount: null,
                });

                this.productBoxUpdated.emit(this.productBoxRegistrations());
            }
        });
    }
}
